module.exports = __webpack_public_path__ + "static/img/FuZhuang_lihuaPic.acd99a17.png";